export default __webpack_public_path__ + "media/images/paylogos/gray/visa-743c22b0a5aad45535420631c714e1cf.png";